import {
  useEffect,
  useState
} from 'react'
import {
  useDispatch,
  useSelector
} from 'react-redux'
import {
  Select,
  Stack
} from '@chakra-ui/react'
import {
  setUserPosition,
  setRandomPos,
  usersSelectors
} from 'store'
import {
  INITIAL_POSITION,
  LOCATION_TYPE
} from 'utils/constants'
import { chatCredentialsSelectors } from 'store/chat/selectors'
import { COLORS } from 'utils/styles'
import { MapModal } from './MapModal'

const getRandomDecimalWithPrecision = (min, max, precision) => {
  const factor = 10 ** precision
  min *= factor
  max *= factor
  return (Math.floor(Math.random() * (max - min + 1)) + min) / factor
}

export const Location = ({
  location_type,
  setSelectLocation,
  incomplete,
  full_name
}) => {
  const dispatch = useDispatch()
  const { userPosition } = useSelector(usersSelectors)
  const { xmppLiveLocation } = useSelector(chatCredentialsSelectors)
  const locationVariant = location_type ? Object.values(location_type)[0] : null
  const [isStaticLocation, setIsStaticLocation] = useState(false)
  const [tempLocationData, setTempLocationData] = useState(null)
  const [isLiveLoc, setIsLiveLoc] = useState(false)
  const [isLiveAppr, setIsLiveAppr] = useState(false)
  const isLocDisabled = localStorage.getItem('isLocDisabled')

  const GetTempLocation = () => {
    const lat = localStorage.getItem('lat')
    const lng = localStorage.getItem('lng')

    if (
      !Number.isNaN(xmppLiveLocation.lat)
      && !Number.isNaN(xmppLiveLocation.lng)
    ) {
      return xmppLiveLocation
    }

    if (
      !Number.isNaN(parseFloat(lat))
      && !Number.isNaN(parseFloat(lng))
    ) {
      return {
        lat,
        lng
      }
    }

    return {
      lat: INITIAL_POSITION[0],
      lng: INITIAL_POSITION[1]
    }
  }

  const setUserPosToLiveLoc = (locType = 0) => {
    let addRadiusLat = 0
    let addRadiusLng = 0

    if (locType === 1) {
      addRadiusLat = getRandomDecimalWithPrecision(-0.001, 0.001, 4)
      addRadiusLng = getRandomDecimalWithPrecision(-0.001, 0.001, 4)
    }

    const liveLocation = GetTempLocation()

    dispatch(setUserPosition([
      Number(liveLocation.lat) + addRadiusLat,
      Number(liveLocation.lng) + addRadiusLng
    ]))
  }

  const handleChangeLocation = (e) => {
    setSelectLocation(e)
    if (+e === 2) {
      setIsStaticLocation(true)
      const liveLocation = GetTempLocation()
      dispatch(setUserPosition([
        liveLocation.lat,
        liveLocation.lng
      ]))
    } else {
      setIsStaticLocation(false)
      setUserPosToLiveLoc(+e)
    }
  }

  useEffect(() => {
    dispatch(setRandomPos({
      lat: Number(parseFloat(userPosition?.[0]
        - getRandomDecimalWithPrecision(-0.001, 0.001, 6)).toFixed(6)),
      lng: Number(parseFloat(userPosition?.[1]
        - getRandomDecimalWithPrecision(-0.001, 0.001, 6)).toFixed(6))
    }))
  }, [userPosition])

  useEffect(() => {
    if (
      isStaticLocation
      && !userPosition
      && !tempLocationData
    ) {
      setTempLocationData(GetTempLocation())
    }
  }, [isStaticLocation])

  useEffect(() => {
    let tempIsStaticLoc = false
    if (!location_type && isLocDisabled !== 'true') {
      tempIsStaticLoc = false
    }

    const savedType = location_type ? Object.values(location_type)[0] : null
    if (savedType === 2) {
      tempIsStaticLoc = true
    } else if (savedType === 1) {
      setIsLiveAppr(true)
      handleChangeLocation(1)
      tempIsStaticLoc = false
    } else if (savedType === 0) {
      setIsLiveLoc(true)
      handleChangeLocation(0)
      tempIsStaticLoc = false
    } else if (isLocDisabled === 'true') {
      // This should run if the geolocation is not working
      if (full_name) {
        setSelectLocation(2)
      }

      handleChangeLocation(2)
      tempIsStaticLoc = true
    } else {
      // This should run if the profile stil doesn't have a full_name and the geolocation is working
      setIsLiveLoc(true)
      handleChangeLocation(0)
      tempIsStaticLoc = false
    }

    setIsStaticLocation(tempIsStaticLoc)
  }, [])

  return (
    <Stack spacing="1rem">
      <Select
        backgroundColor={COLORS.gold}
        _hover={{ background: COLORS.gold_hover }}
        fontSize="18px"
        cursor="pointer"
        onChange={(e) => handleChangeLocation(e.target.value)}
        defaultValue={locationVariant || (isLocDisabled === 'true' ? 2 : 0)}
        name="profile_location"
        _focus={{ boxShadow: 'none' }}
        _focusVisible={{ boxShadow: 'none' }}
        {...(Number(location_type) === 2 && userPosition === null && incomplete === true ? { border: 'solid 1px red' } : {})}
      >
        <option
          value={0}
          selected={isLiveLoc && !isStaticLocation}
          disabled={isLocDisabled === 'true'}
        >
          { LOCATION_TYPE.LiveLocation }
        </option>

        <option
          value={1}
          selected={isLiveAppr && !isStaticLocation}
          disabled={isLocDisabled === 'true'}
        >
          { LOCATION_TYPE.LiveApproximate }
        </option>

        <option
          value={2}
          selected={isStaticLocation}
        >
          { LOCATION_TYPE.StaticLocation }
        </option>
      </Select>

      <MapModal
        isStaticLocation={isStaticLocation}
        tempLocationData={tempLocationData}
        full_name={full_name}
      />
    </Stack>
  )
}
